import isEqual from 'lodash.isequal';
import {CreationAttribute} from 'src/modules/event-create/typedefs';

export const filterAddedAttributes = (
    savedTemplate: CreationAttribute[],
    template: CreationAttribute[],
    addedAttributes: CreationAttribute[],
): CreationAttribute[] => {
    const savedTemplateAttributesNames = savedTemplate.map(attribute => attribute.name);
    const templateAttributesNames = template.map(attribute => attribute.name);

    const addedAttributesOmitSavedTemplate = addedAttributes.filter(attribute =>
        !savedTemplateAttributesNames.includes(attribute.name));
    const resolveAddedAttributes = savedTemplate.length && !isEqual(savedTemplate, template) ?
        addedAttributesOmitSavedTemplate : addedAttributes;

    return resolveAddedAttributes.filter(attribute =>
        !templateAttributesNames.includes(attribute.name) || attribute.id);
};
